export const transformations = [
  {
    id: 0,
    roomType: 'Living Room',
    style: 'Modern',
    decorationLevel: 'Balanced Redesign',
    beforeImage: '/images/real-transformations/0-b.webp',
    afterImage: '/images/real-transformations/0-a.webp',
    description: 'A real living room transformed into a clean modern design while keeping the same room layout.',
  },
  {
    id: 1,
    roomType: 'Bedroom',
    style: 'Minimalist',
    decorationLevel: 'Light Touch',
    beforeImage: '/images/real-transformations/1-b.webp',
    afterImage: '/images/real-transformations/1-a.webp',
    description: 'A bedroom refreshed with a calm minimalist approach and neutral tones.',
  },
  {
    id: 2,
    roomType: 'Kitchen',
    style: 'Scandinavian',
    decorationLevel: 'Full Redesign',
    beforeImage: '/images/real-transformations/2-b.webp',
    afterImage: '/images/real-transformations/2-a.webp',
    description: 'A dated kitchen reimagined as a bright Scandinavian space with clean lines.',
  },
  {
    id: 3,
    roomType: 'Office',
    style: 'Industrial',
    decorationLevel: 'Balanced Redesign',
    beforeImage: '/images/real-transformations/3-b.webp',
    afterImage: '/images/real-transformations/3-a.webp',
    description: 'A home office given an industrial makeover with warm wood and dark metal accents.',
  },
  {
    id: 4,
    roomType: 'Bathroom',
    style: 'Luxury',
    decorationLevel: 'Full Redesign',
    beforeImage: '/images/real-transformations/4-b.webp',
    afterImage: '/images/real-transformations/4-a.webp',
    description: 'A bathroom elevated to a spa-like luxury retreat with marble tones.',
  },
  {
    id: 5,
    roomType: 'Living Room',
    style: 'Coastal',
    decorationLevel: 'Light Touch',
    beforeImage: '/images/real-transformations/5-b.webp',
    afterImage: '/images/real-transformations/5-a.webp',
    description: 'A coastal-inspired living room refresh with natural textures and ocean hues.',
  },
  {
    id: 6,
    roomType: 'Dining Room',
    style: 'Classic',
    decorationLevel: 'Balanced Redesign',
    beforeImage: '/images/real-transformations/6-b.webp',
    afterImage: '/images/real-transformations/6-a.webp',
    description: 'A dining room refreshed with classic details and a more polished atmosphere.',
  },
  {
    id: 7,
    roomType: 'Living Room',
    style: 'Contemporary',
    decorationLevel: 'Full Redesign',
    beforeImage: '/images/real-transformations/7-b.webp',
    afterImage: '/images/real-transformations/7-a.webp',
    description: 'A real room transformed with contemporary furniture, lighting, and decor.',
  },
  {
    id: 8,
    roomType: 'Bedroom',
    style: 'Luxury',
    decorationLevel: 'Balanced Redesign',
    beforeImage: '/images/real-transformations/8-b.webp',
    afterImage: '/images/real-transformations/8-a.webp',
    description: 'A bedroom upgraded with a warmer, more luxurious interior design direction.',
  },
  {
    id: 9,
    roomType: 'Living Room',
    style: 'Modern',
    decorationLevel: 'Full Redesign',
    beforeImage: '/images/real-transformations/9-b.webp',
    afterImage: '/images/real-transformations/9-a.webp',
    description: 'A living room redesigned with modern styling while preserving the original layout.',
  },
];
